// Mercury Landing Frontend App
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

// Импорт модулей
import "../Header/Header.js";
import "../Hotels/Hotels.js";
import "../Tours/Tours.js";
import "../Articles/Articles.js";
import "../Hero/Hero.js";
import "../ResortDescription/ResortDescription.js";
import "../Footer/Footer.js";
import "../Expert/Expert.js";
import "../Contact/Contact.js";
import "../Video/Video.js";
import "../BottomVideo/BottomVideo.js";
import "./section-title-animation.js";
import "./card-links.js";
import "../CookieConsent/CookieConsent.js";

// Инициализация при загрузке страницы
$(document).ready(function() {
    console.log('Mercury Landing Frontend App loaded');
});






